import React, { useContext, useState } from "react";
import { css } from "emotion";
import GenericCard from "../GenericCard";
import ProfileDetails from "./ProfileDetails";
import { boxStyles } from "../../styles/theme";
import WorkspaceSettings from "./WorkspaceSettings";
import ChangePassword from "./ChangePassword";
import GenericButton from "../GenericButton";
import { AccountSettingsState } from "../../context/AccountSettingsState";
import { GlobalContext } from "../../context/GlobalState";
import users from "../../services/api/users";
import workspaces from "../../services/api/workspaces";
import auth from "../../services/api/auth";
import TitleWithBackButton from "../TitleWithBackButton";

const SettingsBody = () => {
  const [isLoading, setLoading] = useState(false);
  const [isCompleted, setCompleted] = useState(false);

  const context = useContext(GlobalContext);
  const {
    updateUser,
    updateWorkspace,
    userData,
    currentWorkspace,
  } = useContext(GlobalContext);
  const settingsState = useContext(AccountSettingsState);
  const handleClick = (e) => {
    setLoading(true);
    e.preventDefault();
    updateSettings();
  };

  const updateSettings = async () => {
    const globalState = [
      userData.firstName,
      userData.lastName,
      userData.emailAddress,
      currentWorkspace.name,
    ];
    const localState = [
      settingsState.firstName,
      settingsState.lastName,
      settingsState.emailAddress,
      settingsState.currentWorkspace.name,
    ];
    let isChangedUser = false;
    let isChangedWorkspace = false;
    for (let i = 0; i < localState.length - 1; i++) {
      if (localState[i] !== globalState[i]) {
        isChangedUser = true;
      }
    }
    if (localState[3] !== globalState[3]) {
      isChangedWorkspace = true;
    }

    if (isChangedUser) {
      try {
        const updatedUser = {
          firstName: settingsState.firstName,
          lastName: settingsState.lastName,
          emailAddress: settingsState.emailAddress,
        };
        await users.updateProfile(updatedUser);
        updateUser(updatedUser);
      } catch (error) {
        console.log(error);
      }
    }

    if (isChangedWorkspace) {
      const updatedWorkspace = {
        name: settingsState.currentWorkspace,
        id: context.currentWorkspace.id,
      };
      try {
        await workspaces.update(updatedWorkspace);
        updateWorkspace(updatedWorkspace.name);
      } catch (error) {
        console.log(error);
      }
    }

    if (settingsState.newPassword) {
      try {
        await auth.updatePassword({ password: settingsState.newPassword });
      } catch (error) {
        console.log(error);
      }
    }

    setCompleted(true);
    setTimeout(() => {
      setLoading(false);
      setCompleted(false);
    }, 2000);
  };

  return (
    <div className={container}>
      <div className="desktop-only">
        <TitleWithBackButton title="Account Settings" backLocation="settings" />
      </div>
      <div className="body">
        <div className="leftColumn">
          <GenericCard style="cardInput">
            <ProfileDetails />
          </GenericCard>
          <GenericCard style="cardInput">
            <ChangePassword />
          </GenericCard>
        </div>
        <div className="rightColumn">
          <GenericCard style="cardInput">
            <WorkspaceSettings />
          </GenericCard>
        </div>
      </div>
      <div className="footer">
        <div className="button">
          <GenericButton
            text={isCompleted ? "Updated!" : "Save Changes"}
            handleClick={handleClick}
            disabled={isLoading}
          />
        </div>
      </div>
    </div>
  );
};

export default SettingsBody;

const container = css`
  display: flex;
  padding: 15px 0;
  flex-direction: column;

  .desktop-only {
    display: none;
    padding: 0 ${boxStyles.standardPadding};
  }

  .body {
    display: flex;
    flex-direction: column;
    flex: 1;
    padding: ${boxStyles.standardPadding};
  }

  .cardInput {
    display: flex;
    justify-content: center;
    width: 100%;
    align-items: center;
    margin: 20px 0;
  }

  .leftColumn {
    display: flex;
    flex: 1;
    flex-direction: column;
    align-items: center;
    padding: 0;
  }

  .rightColumn {
    display: flex;
    flex: 1;
    flex-direction: column;
    align-items: center;
    width: 100%;
    margin: 0;
  }

  .footer {
    display: flex;
    justify-content: center;
    padding: 30px 0;
  }
  .button {
    width: 200px;
    margin: auto;
  }

  @media screen and (min-width: ${boxStyles.desktopBreak}) {
    .desktop-only {
      display: block;
    }
    .body {
      flex-direction: row;
    }
    .footer {
      padding: 80px 0 0;
    }

    .button {
      width: 200px;
      margin-right: auto;
      margin-left: 15px;
    }
    .cardInput {
      width: 100%;
    }
    .leftColumn {
      padding-right: 30px;
    }
  }
`;
